import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12.667 2.708a.62.62 0 0 1 .625.625v3.334a.625.625 0 1 1-1.25 0V4.842l-2.17 2.17a3.958 3.958 0 1 1-.883-.884l2.169-2.17H9.333a.625.625 0 1 1 0-1.25zm-7.915 4.71a2.708 2.708 0 1 1 3.83 3.83 2.708 2.708 0 0 1-3.83-3.83",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })